module.exports = __webpack_public_path__ + "img/Weapon_257.b765d852.png";